import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { PurchaseApplication } from './pages/PurchaseApplication';
import { RefinanceApplication } from './pages/RefinanceApplication';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/purchase" element={<PurchaseApplication data-id="element-5" />} data-id="element-4" />
        <Route path="/refinance" element={<RefinanceApplication data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}